import { connect } from "react-redux";

import AnswerStart from "components/answer/AnswerStart";

import { setAuthErrorType } from "redux/modules/answer/answerLogin";
import {
  set as setAnswerStart,
  changeLocale,
  setTemporarySaved,
  clearTemporarySaved,
  setTempSavedAttrResult,
  setTempSavedBasicResult,
  setRespondent
} from "redux/modules/answer/answerStart";
import { set as setSurveyLocale } from "redux/modules/answer/attributeReady";
import { set as setSurveyAttrs, setNextSurveyAttr, setCurrentSurveyAttrOrder, setCurrentSurveyAttr } from "redux/modules/answer/answerAttribute";
import { set as setQuestions } from "redux/modules/answer/answerQuestion";
import { setCurrentQuestion } from "redux/modules/answer/answerQuestion";
import { setFreeCommentDescriptions, setNextPage } from "redux/modules/answer/answerOther";
import {
  setHeaderInfo,
  startEffect,
  finishEffect
} from "redux/modules/answer/answerHeader";
import { init as attributeReadyInit } from "redux/modules/answer/attributeReady";
import { setLocale, setLocales, setAttrResultBulk, setBasicResultBulk, clearTempSavedData, setAdditionResultBulk, changeFreeCommentText } from "redux/modules/answer/answerResult";
import { openErrorDialog } from "redux/modules/errorDialog";

import history from "utils/history";
import storage from "utils/storage";
import { answerLoginURL } from "utils/formatter";
import api from "api";

const mapStateToProps = state => ({
  answerStart: state.answerStart,
  answerHeader: state.answerHeader,
  answerResult: state.answerResult
});

function hydrateAttrResult(permanentSavedState, surveyAttrs) {
  const hydrated = {};

  permanentSavedState.attrResults.forEach(result => {
    // find surveyAttr by its ID
    const surveyAttr = Object.values(surveyAttrs)
      .find(a => a.id === result.surveyAttrId);

    if (!surveyAttr) return;

    // find attrItem inside surveyAttr
    const attrItem = surveyAttr.attrItems.find(
      item => item.id === result.attrItemId
    );

    hydrated[surveyAttr.order] = {
      surveyAttr,
      attrItem
    };
  });

  return hydrated;
}

function hydrateBasicResult(permanentSavedState, basicQuestionsFromRedux) {
  const surveyResult = permanentSavedState.surveyResult;
  const hydrated = {};

  basicQuestionsFromRedux.forEach(question => {
    const qNo = question.qNo;

    const num = surveyResult[`q${qNo}`];  // e.g. q1, q2, ...

    if (num !== undefined && num !== null) {
      hydrated[qNo] = {
        question,
        num
      };
    }
  });

  return hydrated;
}

function hydrateAdditionResult(permanentSavedState, additionsFromRedux) {
  const hydrated = {};

  permanentSavedState.additionResults.forEach(ar => {
    const addition = additionsFromRedux.find(a => a.id === ar.additionId);
    if (!addition) return;

    const choice = addition.choices.find(c => c.id === ar.additionChoiceId);
    if (!choice) return;

    hydrated[addition.qNo] = {
      addition,
      choice
    };
  });

  return hydrated;
}

function hydrateFreeComments(permanentSavedState) {
  const { freeComment1, freeComment2 } = permanentSavedState.surveyResult;
  
  return {
    freeComment1: freeComment1 || "",
    freeComment2: freeComment2 || ""
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  showErrorDialog: () => {
    dispatch(openErrorDialog(new Error("authError")));
  },
  fetchAnswerStart: (answerToken, localeId) => {
    const params = { urlToken: storage.getUrlToken(), answerToken, id: storage.getSurveyId() };

    const response = api
      .get("start", params)
      .then(res => {
        if (res.invalidStatusError) {
          dispatch(setAuthErrorType("canNotAnswer"));
          history.push(answerLoginURL(), ownProps);
        } else {
          dispatch(setAnswerStart(res.surveyLocales, localeId));
          dispatch(setHeaderInfo(res.headerInfo));
          dispatch(setLocales(res.surveyLocales));
          dispatch(
            setRespondent(res.emailSent)
          );
          if (res.tempSave) {
            dispatch(
              setTemporarySaved(res.tempSave, res.tempSavedPath)
            );
            dispatch(setTempSavedAttrResult(res.tempSavedState.attrResult));
            dispatch(setTempSavedBasicResult(res.tempSavedState.basicResult));
            dispatch(setAttrResultBulk(res.tempSavedState.attrResult));
            dispatch(setBasicResultBulk(res.tempSavedState.basicResult));
            dispatch(setAdditionResultBulk(res.tempSavedState.additionResult));
            dispatch(setLocale(res.tempSavedState.localeId));
            if (res.freeComment1) {
              dispatch(changeFreeCommentText("freeComment1", res.freeComment1))
            }
            if(res.freeComment2) {
              dispatch(changeFreeCommentText("freeComment2", res.freeComment2))
              dispatch(setNextPage());
            }
          }
          return res;
        }
      })
      .catch(error => {
        dispatch(openErrorDialog(error));
        return null; // prevent undefined return
      });
      return response;
  },
  changeLocale: localeId => {
    dispatch(changeLocale(localeId));
    // 属性開始画面を初期化する
    dispatch(attributeReadyInit());
  },
  handleStart: localeId => {
    dispatch(setLocale(localeId));

    dispatch(startEffect());
    setTimeout(() => {
      history.push(`/attribute_ready`, ownProps);

      dispatch(finishEffect());
    }, 300);
  },
  clearTemporarySaved: () => {
    dispatch(clearTemporarySaved());
    dispatch(clearTempSavedData());
  },
  fetchAttributeReady: (answerToken, localeId, currentPage, redirectPath, attributePage, permanentSave, permanentSavedState) => {
    const params = {
      answer_token: answerToken,
      localeId,
      url_token: storage.getUrlToken(),
      id: storage.getSurveyId()
    };

    api
      .get("attr_ready", params)
      .then(res => {
        dispatch(setHeaderInfo(res.headerInfo));
        dispatch(setSurveyLocale(res.surveyLocale));
        dispatch(setSurveyAttrs(res.surveyAttrs));
        dispatch(setQuestions(res.basicQuestions, res.additions));
        dispatch(setFreeCommentDescriptions(res.freeCommentDescriptions));
        if (permanentSave) {
          dispatch(setLocale(permanentSavedState.surveyResult.localeId));
          const attrResultHydrated = hydrateAttrResult(
            permanentSavedState,
            res.surveyAttrs
          );
        
          dispatch(setAttrResultBulk(attrResultHydrated));
        
          const basicResultHydrated = hydrateBasicResult(
            permanentSavedState,
            res.basicQuestions
          );
          dispatch(setBasicResultBulk(basicResultHydrated));

          const additionResultHydrated = hydrateAdditionResult(
            permanentSavedState,
            res.additions
          );
          
          dispatch(setAdditionResultBulk(additionResultHydrated));

          const freeCommentsHydrated = hydrateFreeComments(permanentSavedState);
          dispatch(changeFreeCommentText("freeComment1", freeCommentsHydrated.freeComment1));
          dispatch(changeFreeCommentText("freeComment2", freeCommentsHydrated.freeComment2));

        }
        if (redirectPath === '/answer_question') {
          dispatch(setCurrentQuestion(currentPage));
          dispatch(setCurrentSurveyAttrOrder(attributePage));
          dispatch(setCurrentSurveyAttr(attributePage));
        }
        else if (redirectPath === '/other') {
          dispatch(setCurrentQuestion(currentPage - 1));
          dispatch(setCurrentSurveyAttrOrder(attributePage));
          dispatch(setCurrentSurveyAttr(attributePage));
        }
         else {
          dispatch(setCurrentSurveyAttrOrder(currentPage));
          dispatch(setNextSurveyAttr());
        }
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AnswerStart);



// WEBPACK FOOTER //
// ./src/containers/answer/AnswerStartContainer.js